import React from 'react'
import NotFound from 'containers/NotFound'
import { Route, Routes, useRoutes, useLocation, Navigate, useParams, generatePath } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { buildRoutes } from 'routes'
import { withTracker } from 'tracking'

const Redirect = ({ from, to }) => {
  const { search } = useLocation()
  const params = useParams()

  return (
    <Navigate from={from} to={generatePath(to + search, params)} />
  )
}

const AppRoutes = () => {
  const { formatMessage } = useIntl()
  const routesConfig = buildRoutes(formatMessage)
  const redirects = [
    { from: '/search', to: '/' },
    { from: '/suche', to: '/' },
    { from: '/søg', to: '/' },
    { from: '/søg/:id', to: '/:id' },
    { from: '/search/:id', to: '/:id' },
    { from: '/suche/:id', to: '/:id' },
  ]

  const redirectsConfig = redirects.map(({ from, to }) => ({
    path: from,
    element: <Redirect from={from} to={to} />,
  }))

  const config = [
    ...routesConfig,
    ...redirectsConfig,
  ]

  return useRoutes(config)
}

export default AppRoutes
